import { ApiError, currentSession, login, logout } from "./api";
import { isOwner, state } from "./state";
import { closeModal, element, errorMessage } from "./ui";

export interface SessionCallbacks {
  authenticated(): Promise<void>;
  loggedOut(): void;
}

function applyRoleUi(): void {
  document.body.dataset.role = state.role || "";
  element<HTMLButtonElement>("addBtn").hidden = !isOwner();
  const badge = element<HTMLElement>("roleBadge");
  badge.hidden = !state.role;
  badge.textContent = state.roleLabel;
  badge.dataset.role = state.role || "";
  element<HTMLElement>("settingsRoleLabel").textContent = state.roleLabel || "—";
}

function clearSessionState(): void {
  state.role = null;
  state.roleLabel = "";
  state.orders = [];
}

export function showLoginGate(): void {
  clearSessionState();
  element<HTMLElement>("loginGate").hidden = false;
  element<HTMLElement>("appRoot").hidden = true;
  applyRoleUi();
}

function showApp(): void {
  element<HTMLElement>("loginGate").hidden = true;
  const app = element<HTMLElement>("appRoot");
  app.hidden = false;
  app.inert = false;
  applyRoleUi();
}

function loginMessage(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.code === "invalid_code") return "代号不正确";
    if (error.code === "server_auth_not_configured") return "服务端未配置登录，请联系管理员";
  }
  return errorMessage(error, "登录失败，请稍后重试");
}

export async function restoreSession(): Promise<boolean> {
  try {
    const session = await currentSession();
    state.role = session.role;
    state.roleLabel = session.label;
    showApp();
    return true;
  } catch (error) {
    if (error instanceof ApiError && error.status === 401) {
      showLoginGate();
      return false;
    }
    throw error;
  }
}

export function initSession(callbacks: SessionCallbacks): void {
  const form = element<HTMLFormElement>("loginForm");
  const input = element<HTMLInputElement>("loginCode");
  const errorElement = element<HTMLElement>("loginError");
  const submit = element<HTMLButtonElement>("loginSubmit");
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    errorElement.hidden = true;
    submit.disabled = true;
    submit.textContent = "验证中…";
    try {
      const session = await login(input.value.trim());
      state.role = session.role;
      state.roleLabel = session.label;
      showApp();
      await callbacks.authenticated();
    } catch (error) {
      errorElement.textContent = loginMessage(error);
      errorElement.hidden = false;
    } finally {
      submit.disabled = false;
      submit.textContent = "进入";
    }
  });
  element<HTMLButtonElement>("logoutBtn").addEventListener("click", async () => {
    callbacks.loggedOut();
    await logout().catch(() => undefined);
    showLoginGate();
    closeModal(element<HTMLElement>("settingsModal"));
    input.value = "";
    input.focus();
  });
}
